import React from "react";

function DownloadAppSection() {
  return (
    <div className="flex flex-col items-center justify-center bg-[#fbf9f5]  font-Poppins">
      {/* Title Section */}
      <div className="font-bold text-3xl sm:text-4xl text-gray-800 my-4 mt-[5%] text-center">
        Download Taxica India
      </div>
      <img
        src="./assets/border.webp"
        className="my-3"
        alt="Header Decoration"
      />

      {/* Main Content Section */}

      <div className="flex flex-col lg:flex-row items-center justify-between max-w-7xl px-4 sm:px-8">
        {/* Phone Mockup Section */}
        <div className="w-full lg:w-2/5 h-auto mt-[5%] flex justify-center">
          <img
            src="./assets/userapp.jpg"
            className="w-full h-auto object-contain max-w-[300px] lg:max-w-none"
            alt="Taxica App Mockup"
          />
        </div>

        {/* Text and Download Section */}
        <div className="w-full lg:w-1/2 flex flex-col space-y-4 text-center lg:text-left mt-6 lg:mt-0">
          <div className="font-semibold text-xl sm:text-2xl text-gray-800">
            Download the Taxica India Customer Mobile Application
          </div>
          <p className="text-gray-600">
            Taxica India brings convenient taxi services at your fingertips. Get
            our app today to book rides quickly and securely. Available on both
            iOS and Android.
          </p>
          {/* Download Buttons */}
          <div className="flex justify-center lg:justify-start">
            <a
              href="#"
              //   className="bg-black text-white py-2 px-4 rounded-lg flex items-center space-x-2 shadow-md hover:bg-gray-800"
            >
              {/* <img
                src="https://carrgohtml.tortoizthemes.com/assets/images/download-1.webp"
                alt="Google Play"
                className="hover:opacity-80 rounded-lg"
              /> */}
            </a>
            <a
              href="https://play.google.com/apps/testing/com.maapa2019.taxidriverapp"
              target="_blank"
              rel="noreferrer"
              //   className="bg-black text-white py-2 px-4 rounded-lg flex items-center space-x-2 shadow-md hover:bg-gray-800"
            >
              <img
                src="./assets/download.webp"
                alt="App Store"
                className="hover:opacity-80 rounded-lg"
              />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white flex w-full items-center justify-center">
        <div className="flex flex-col-reverse lg:flex-row-reverse items-center justify-between max-w-7xl px-4 sm:px-8">
          {/* Phone Mockup Section */}
          <div className="w-full lg:w-2/5 h-auto mt-[5%] flex justify-center">
            <img
              src="./assets/driverapp.png"
              className="w-full h-auto object-contain max-w-[300px] lg:max-w-none"
              alt="Taxica App Mockup"
            />
          </div>

          {/* Text and Download Section */}
          <div className="w-full lg:w-1/2 flex flex-col space-y-4 text-center lg:text-left mt-6 lg:mt-0">
            <div className="font-semibold text-xl sm:text-2xl text-gray-800">
              Download the Taxica India Driver Mobile Application
            </div>
            <p className="text-gray-600">
              Taxica India brings convenient taxi services at your fingertips.
              Get our app today to book rides quickly and securely. Available on
              both iOS and Android.
            </p>
            {/* Download Buttons */}
            <div className="flex justify-center lg:justify-start  ">
              <a
                href="#"
                //   className="bg-black text-white py-2 px-4 rounded-lg flex items-center space-x-2 shadow-md hover:bg-gray-800"
              >
                {/* <img
                  src="https://carrgohtml.tortoizthemes.com/assets/images/download-1.webp"
                  alt="Google Play"
                  className="hover:opacity-80 rounded-lg"
                /> */}
              </a>
              <a
                href="https://play.google.com/apps/testing/com.maapa2019.taxidriverapp"
                target="_blank"
                rel="noreferrer"
                //   className="bg-black text-white py-2 px-4 rounded-lg flex items-center space-x-2 shadow-md hover:bg-gray-800"
              >
                <img
                  src="./assets/download.webp"
                  alt="App Store"
                  className="hover:opacity-80 rounded-lg"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DownloadAppSection;
